import type { MessageKey } from "./ru"

export const viMessages = {
  "common.loading": "Đang tải...",
  "common.error": "Lỗi",
  "common.back": "Quay lại",
  "common.next": "Tiếp theo",
  "common.search": "Tìm kiếm",
  "auth.loginErrorTitle": "Lỗi đăng nhập",
  "auth.openViaTelegram": "Mở ứng dụng qua Telegram",
  "auth.telegramRequired": "Ứng dụng phải được mở qua Telegram",
  "auth.authorizationError": "Lỗi xác thực",
  "device.rotatePortrait": "Xoay thiết bị sang chế độ dọc",
  "country.brazil": "Brazil",
  "country.vietnam": "Việt Nam",
  "country.egypt": "Ai Cập",
  "country.india": "Ấn Độ",
  "country.indonesia": "Indonesia",
  "country.iran": "Iran",
  "country.spain": "Tây Ban Nha",
  "country.italy": "Ý",
  "country.kazakhstan": "Kazakhstan",
  "country.colombia": "Colombia",
  "country.malaysia": "Malaysia",
  "country.mexico": "Mexico",
  "country.nigeria": "Nigeria",
  "country.pakistan": "Pakistan",
  "country.russia": "Nga",
  "country.usa": "Hoa Kỳ",
  "country.turkey": "Türkiye",
  "country.uzbekistan": "Uzbekistan",
  "country.ukraine": "Ukraine",
  "country.philippines": "Philippines",
  "countrySelection.chooseCountry": "Chọn quốc gia",
  "countrySelection.openAria": "Chọn quốc gia",
  "languageSelection.chooseLanguage": "Chọn ngôn ngữ",
  "commercial.direction.autotrade": "Chợ xe",
  "commercial.direction.insurance": "Bảo hiểm",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "Hỗ trợ bên đường",
  "commercial.searchLabel": "Tìm kiếm BeepApp",
  "commercial.cityPlaceholder": "Nhập thành phố",
  "commercial.emptyTitle": "Hôm nay chưa có ưu đãi",
  "commercial.emptyLine1": "Thành phố của bạn chưa có đối tác BeepApp đang hoạt động",
  "commercial.emptyLine2": "Chúng tôi đang tìm kiếm và kết nối các đối tác",
  "commercial.emptyLine3": "Ưu đãi mới sẽ tự động xuất hiện tại đây",
  "commercial.helperLine1": "Nhập thành phố để xem",
  "commercial.helperLine2": "các ưu đãi hiện có",
  "commercial.partnerPrompt": "Bạn muốn trở thành đối tác BeepApp?",
  "commercial.apply": "Đăng ký",
  "main.admin": "Quản trị",
  "main.garage": "Garage",
  "main.signalSent": "Đã gửi tín hiệu",
  "main.partnerInviteUnavailable": "Lời mời đối tác không khả dụng",
  "main.enterPlate": "Nhập biển số xe",
  "main.searchError": "Lỗi tìm kiếm",
  "main.signalSendError": "Không thể gửi tín hiệu",
  "main.shareCardPrefix": "Thẻ biển số",
  "main.shareLinkError": "Không thể tạo liên kết",
  "main.searchByPlateAria": "Tìm theo biển số xe",
  "main.russianPlateAria": "Biển số xe Nga",
  "main.plateAria": "Biển số xe",
  "main.findPlateAria": "Tìm biển số",
  "main.loadingVehicle": "Đang tải thẻ biển số…",
  "main.leaveSignal": "Gửi tín hiệu",
  "main.share": "Chia sẻ",
  "signalSelection.chooseType": "Chọn loại tín hiệu",
  "signalSelection.category.attention": "Cá nhân",
  "signalSelection.category.road": "Đường bộ",
  "signalSelection.category.urgent": "Khẩn cấp",
  "signalSelection.chooseSignal": "Chọn tín hiệu",
  "signalSelection.suggestOwn": "Đề xuất tùy chọn khác",
  "signalConfirmation.title": "Xác nhận tín hiệu",
  "signalConfirmation.plateHeading": "Kiểm tra biển số xe",
  "signalConfirmation.signalHeading": "Kiểm tra tín hiệu đã chọn",
  "signalConfirmation.replyTitle": "Cho phép trả lời trên Telegram",
  "signalConfirmation.replyBody": "Bật tính năng này để chủ biển số có thể\nnhắn tin cho bạn trên Telegram. Chỉ có thể trả lời nếu\nbạn có @username. Quyết định trả lời hoàn toàn\nthuộc về chủ biển số.",
  "signalConfirmation.consentText": "Tôi xác nhận tín hiệu này phản ánh\ntình huống thực tế và không phải spam\nhoặc báo cáo sai.",
  "signalConfirmation.warning": "Sau khi gửi, tín hiệu\nkhông thể thay đổi",
  "signalConfirmation.sending": "Đang gửi…",
  "signalConfirmation.send": "Gửi",
  "partner.loadingAria": "Đang tải",
  "partner.title": "Chương trình đối tác",
  "partner.offerLine1": "Nhận 30% từ mọi khoản thanh toán không giới hạn thời gian",
  "partner.offerLine2": "của người dùng bạn mời vào BeepApp",
  "partner.offerLine3": "thông qua chương trình affiliate của Telegram",
  "partner.connectUnavailable": "Kết nối sẽ khả dụng sau khi chương trình Telegram Affiliate được thiết lập.",
  "partner.connectTelegram": "Kết nối trên Telegram",
  "partner.qrAria": "Mã QR liên kết đối tác",
  "partner.download": "Tải xuống",
  "partner.promoHeading": "Tạo mã khuyến mãi cá nhân",
  "partner.promoHelperLine1": "Mã khuyến mãi kích hoạt thêm một năm đăng ký",
  "partner.promoHelperLine2": "và giúp thu hút người dùng",
  "partner.promoAria": "Mã khuyến mãi",
  "partner.affiliateHeading": "Liên kết affiliate của bạn",
  "partner.affiliateHelper": "Lưu liên kết để tạo mã QR cá nhân",
  "partner.affiliateAria": "Liên kết affiliate",
  "partner.qrNoteLine1": "Mã QR có thể được đặt trên xe,",
  "partner.qrNoteLine2": "trên mạng xã hội và tài liệu quảng cáo",
  "partner.save": "Lưu",
  "partner.reset": "Đặt lại",
  "partner.resetConfirm": "Đặt lại liên kết affiliate đã lưu? Mã khuyến mãi vẫn thuộc về bạn.",
  "partner.promoFormatError": "Mã khuyến mãi phải có từ 4 đến 15 ký tự.",
  "partner.affiliateHostError": "Chỉ cho phép liên kết t.me hoặc telegram.me.",
  "partner.affiliatePathError": "Liên kết không có đường dẫn Telegram.",
  "partner.affiliateFormatError": "Liên kết affiliate không hợp lệ.",
  "partner.loadError": "Lỗi tải dữ liệu",
  "partner.checkInputError": "Kiểm tra thông tin đã nhập",
  "garageActivation.promoInvalid": "Mã khuyến mãi không hợp lệ",
  "garageActivation.plateOccupied": "Biển số này đã được liên kết",
  "garageActivation.activateError": "Không thể kích hoạt Garage",
  "garageEntry.loadJournalError": "Không thể tải nhật ký",
  "garageEntry.loadStatusesError": "Không thể tải trạng thái",
  "garageEntry.activationSuccess": "Đã kích hoạt Garage thành công",
  "garageEntry.plateAttached": "Đã liên kết biển số",
  "garageEntry.attachError": "Không thể liên kết biển số",
  "garageEntry.activationNote": "Kích hoạt Garage của bạn",
  "garageSheet.activationTitle": "Kích hoạt Garage",
  "garageSheet.plateHelper": "Nhập biển số xe",
  "garageSheet.promoHelper": "Bạn có mã khuyến mãi?",
  "garageSheet.cleanBonusLine1": "Sau khi kích hoạt, bạn có 1 giờ",
  "garageSheet.cleanBonusLine2": "để dùng “Khởi đầu sạch” miễn phí",
  "garageSheet.activationFor": "Kích hoạt trong",
  "garageSheet.cost": "Chi phí",
  "garageSheet.ownerConsentLine1": "Tôi xác nhận mình là chủ sở hữu",
  "garageSheet.ownerConsentLine2": "của phương tiện có biển số",
  "garageSheet.ownerConsentLine3": "đã nêu.",
  "garageSheet.processing": "Đang xử lý...",
  "garageSheet.attach": "Liên kết",
  "garageSheet.pay": "Thanh toán",
  "garageLifecycle.cleanTitle": "Khởi đầu sạch",
  "garageLifecycle.deactivateTitle": "Tắt Garage",
  "garageLifecycle.cleanWarningLine1": "Lịch sử biển số sẽ bị xóa",
  "garageLifecycle.cleanWarningLine2": "và không thể khôi phục!",
  "garageLifecycle.deactivateWarningLine1": "Sau khi tắt, quyền truy cập vào các chức năng",
  "garageLifecycle.deactivateWarningLine2": "của Garage đang hoạt động sẽ chấm dứt",
  "garageLifecycle.willBeDeleted": "SẼ BỊ XÓA",
  "garageLifecycle.cleanRemovedLine1": "• Tất cả mục trong Nhật ký",
  "garageLifecycle.cleanRemovedLine2": "• Lịch sử tín hiệu đã nhận",
  "garageLifecycle.cleanRemovedLine3": "• Bộ đếm tín hiệu công khai",
  "garageLifecycle.cleanRemovedLine4": "  trên thẻ biển số",
  "garageLifecycle.willRemain": "SẼ ĐƯỢC GIỮ LẠI",
  "garageLifecycle.cleanPreservedLine1": "• Liên kết biển số với Garage",
  "garageLifecycle.cleanPreservedLine2": "• Thời hạn kích hoạt còn lại",
  "garageLifecycle.cleanPreservedLine3": "• Trạng thái biển số đã chọn",
  "garageLifecycle.cleanPreservedLine4": "• Tổng lượt xem thẻ biển số",
  "garageLifecycle.freeFirstHour": "Miễn phí trong giờ đầu tiên",
  "garageLifecycle.willBecomeUnavailable": "SẼ KHÔNG CÒN KHẢ DỤNG",
  "garageLifecycle.deactivateRemovedLine1": "• Nhật ký",
  "garageLifecycle.deactivateRemovedLine2": "• Chọn và sử dụng trạng thái biển số",
  "garageLifecycle.deactivateRemovedLine3": "• Tự động rời AutoClan",
  "garageLifecycle.deactivateRemovedLine4": "• Chợ xe",
  "garageLifecycle.deactivateRemovedLine5": "• Bảo hiểm",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• Hỗ trợ bên đường",
  "garageLifecycle.deactivateRemovedLine8": "• Biển số sẽ được gỡ khỏi Garage",
  "garageLifecycle.willRemainAvailable": "VẪN KHẢ DỤNG",
  "garageLifecycle.deactivatePreservedLine1": "• Đồng hành",
  "garageLifecycle.deactivatePreservedLine2": "• Điều phối viên",
  "garageLifecycle.deactivatePreservedLine3": "• Tìm kiếm theo biển số và xem",
  "garageLifecycle.deactivatePreservedLine4": "  thẻ xe công khai",
  "garageLifecycle.deactivatePreservedLine5": "• Có thể kích hoạt lại",
  "garageLifecycle.deactivatePreservedLine6": "  Garage bất cứ lúc nào",
  "garageLifecycle.cleanConsentLine1": "Tôi đồng ý xóa",
  "garageLifecycle.cleanConsentLine2": "toàn bộ lịch sử của biển số này",
  "garageLifecycle.cleanConsentLine3": "và không thể khôi phục.",
  "garageLifecycle.deactivateConsentLine1": "Tôi xác nhận tắt Garage và",
  "garageLifecycle.deactivateConsentLine2": "chấm dứt quyền truy cập vào tất cả",
  "garageLifecycle.deactivateConsentLine3": "các chức năng Garage đang hoạt động.",
  "garageLifecycle.clean": "Xóa sạch",
  "garageLifecycle.deactivate": "Tắt",
} satisfies Record<MessageKey, string>
